import { render } from "./Webinars.vue?vue&type=template&id=ab406dc8"
const script = {}

import "@/styles/profile/webinars/groups.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__